import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ProtectedRoute } from '../components/layout/protected-route';
import { DashboardLayout } from '../components/layout/dashboard-layout';
import { SetupScreen } from './Setup';
import { LoginScreen } from './Login';
import { CustomLoginScreen } from './CustomLogin';
import { OAuthCallback } from './OAuthCallback';
import { ForgotPasswordScreen } from './ForgotPassword';
import { ResetPasswordScreen } from './ResetPassword';
import { DashboardScreen } from './Dashboard';
import { ProfileScreen } from './Profile';
import { OrganizationList } from './Organizations';
import { CreateOrganization } from './Organizations/Create';
import { EditOrganization } from './Organizations/Edit';
import { ApplicationList } from './Applications';
import { CreateApplication } from './Applications/Create';
import { EditApplication } from './Applications/Edit';
import { UserList } from './Users';
import { CreateUser } from './Users/Create';
import { EditUser } from './Users/Edit';
import { BulkImportExport } from './Users/BulkImportExport';
import { AuditLogs } from './AuditLogs';
import { RoleList } from './Roles';
import { CreateRole } from './Roles/Create';
import { EditRole } from './Roles/Edit';

export function AppRouter() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public Routes */}
        <Route path="/setup" element={<SetupScreen />} />
        <Route path="/login" element={<LoginScreen />} />
        <Route path="/custom/login" element={<CustomLoginScreen />} />
        <Route path="/oauth-callback" element={<OAuthCallback />} />
        <Route path="/custom/forgot-password" element={<ForgotPasswordScreen />} />
        <Route path="/custom/reset-password" element={<ResetPasswordScreen />} />

        {/* Protected Routes with Dashboard Layout */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <DashboardLayout />
            </ProtectedRoute>
          }
        >
          {/* Dashboard Home */}
          <Route index element={<DashboardScreen />} />

          {/* Organization Management - Super Admin Only */}
          <Route
            path="orgs"
            element={
              <ProtectedRoute requireSuperAdmin>
                <OrganizationList />
              </ProtectedRoute>
            }
          />
          <Route
            path="orgs/create"
            element={
              <ProtectedRoute requireSuperAdmin>
                <CreateOrganization />
              </ProtectedRoute>
            }
          />
          <Route
            path="orgs/:id"
            element={
              <ProtectedRoute requireSuperAdmin>
                <EditOrganization />
              </ProtectedRoute>
            }
          />

          {/* Application Management - Admin & Super Admin Only */}
          <Route
            path="apps"
            element={
              <ProtectedRoute requireAdmin>
                <ApplicationList />
              </ProtectedRoute>
            }
          />
          <Route
            path="apps/create"
            element={
              <ProtectedRoute requireAdmin>
                <CreateApplication />
              </ProtectedRoute>
            }
          />
          <Route
            path="apps/:id"
            element={
              <ProtectedRoute requireAdmin>
                <EditApplication />
              </ProtectedRoute>
            }
          />

          {/* Profile */}
          <Route path="profile" element={<ProfileScreen />} />

          {/* User Management - Super Admin Only */}
          <Route
            path="users"
            element={
              <ProtectedRoute requireSuperAdmin>
                <UserList />
              </ProtectedRoute>
            }
          />
          <Route
            path="users/create"
            element={
              <ProtectedRoute requireSuperAdmin>
                <CreateUser />
              </ProtectedRoute>
            }
          />
          <Route
            path="users/bulk"
            element={
              <ProtectedRoute requireSuperAdmin>
                <BulkImportExport />
              </ProtectedRoute>
            }
          />
          <Route
            path="users/:id"
            element={
              <ProtectedRoute requireSuperAdmin>
                <EditUser />
              </ProtectedRoute>
            }
          />

          {/* Role Management - Super Admin Only */}
          <Route
            path="roles"
            element={
              <ProtectedRoute requireSuperAdmin>
                <RoleList />
              </ProtectedRoute>
            }
          />
          <Route
            path="roles/create"
            element={
              <ProtectedRoute requireSuperAdmin>
                <CreateRole />
              </ProtectedRoute>
            }
          />
          <Route
            path="roles/:id"
            element={
              <ProtectedRoute requireSuperAdmin>
                <EditRole />
              </ProtectedRoute>
            }
          />

          {/* Audit Logs - Super Admin Only */}
          <Route
            path="audit"
            element={
              <ProtectedRoute requireSuperAdmin>
                <AuditLogs />
              </ProtectedRoute>
            }
          />
        </Route>

        {/* Root Redirects */}
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
